module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/thanks/1910_Thankyou_Thankyou-19a60cf260580e3646ec575f7b380797.jpg";